// Angular
import {InjectionToken, NgModule} from '@angular/core';

// NgRx
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {UserEffects} from './user.effects';
import {userReducer, userStateFeatureKey} from './user.reducers';

// Utils
import {provideBootstrapEffects} from '@core/utils/ngrx-utilities';

export const USER_EFFECTS = new InjectionToken('User Effects');

@NgModule({
  imports: [
    StoreModule.forFeature(userStateFeatureKey, userReducer),
    EffectsModule
  ],
  providers: [
    provideBootstrapEffects(USER_EFFECTS, [UserEffects])
  ]
})
export class UserModule {
}
